/**
 * The audience line under a shared chat's title.
 *
 * Whoever opens a share link did not configure the chat, so the old subtitle
 * ("Shared conversation (N messages)") told them nothing about WHICH cohort or
 * segment produced the answers. The message count was never the useful fact here;
 * the audience is, so this replaces it.
 *
 * The backend sends the label already collapsed ("Multiple profiles" when more
 * than one cohort was picked); this only formats it for display, matching the live
 * chat header exactly so a shared conversation names its audience the same way as
 * the conversation it came from.
 */
import { audienceSummary } from '../marketplace/audienceLabel';

const SEPARATOR = ' · ';

/** "5 Twins · Cereal › Protein Purists", or null when nothing is known. */
export function sharedAudienceLine(
  audienceLabel?: string | null,
  twinCount?: number | null,
): string | null {
  // audienceSummary turns the backend's "Cereal: Protein Purists" into
  // "Cereal › Protein Purists" — the same transform the studies list applies.
  const audience = audienceLabel ? audienceSummary([audienceLabel]) : null;
  // Omitted rather than shown as "0 Twins": a platform chat has no in-memory
  // audience, and zero would be a lie.
  const twins =
    twinCount != null && twinCount > 0
      ? `${twinCount} Twin${twinCount === 1 ? '' : 's'}`
      : null;
  const parts = [twins, audience].filter(Boolean);
  return parts.length > 0 ? parts.join(SEPARATOR) : null;
}
